import React from "react";
import { Welcome } from "../comps/welcome/welcome";
import { ColorSchemeToggle } from "../comps/toggle/toggle";

export default function HomePage() {
  return (
    <>
      <Welcome />
      <ColorSchemeToggle />
    </>
  );
}

// https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
export const Head = () => (<title>Galasee Stories</title>)
